import React, { useEffect } from "react";
import useCustomMutation from "../../../Hooks/useCustomMutation";
import { Spinner } from "reactstrap";

const DeleteForm = ({ setIsToggleDelete, eventID, sessionID, token }) => {
  const key = ["mySessions", eventID];
  const mutation = useCustomMutation(key);
  const DeleteSession = () => {
    const Method = "DELETE",
      url = `sessions/${sessionID}`,
      isJSON = null;
    var raw = null;
    const data = {
      endPoint: url,
      bodyContent: raw,
      Method: Method,
      displayMessage: "Session successfully deleted",
      token: token,
      isJSON: isJSON,
    };
    mutation.mutate(data);
  };

  useEffect(() => {
    if (mutation?.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutation?.isSuccess]);

  return (
    <div className="w-100">
      <h5 className="text-danger">
        Are you sure you want to delete this Session ?
      </h5>
      <div className="modal-footer d-flex justify-content-between">
        <button
          onClick={() => {
            setIsToggleDelete(false);
          }}
          type="button"
          className="btn btn-dark"
        >
          Cancel
        </button>
        <button
          onClick={DeleteSession}
          type="button"
          className="btn btn-danger"
        >
          {!mutation.isLoading ? (
            <span className="px-2">Sure</span>
          ) : (
            <span>
              <Spinner as="span" animation="border" size="sm" />
              Loading
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default DeleteForm;
